export function getAuthorValue(authorId) {
    return authorId << 12;
}
export function isAuthor(id, authorId) {
    return (id & (0xf << 12)) === getAuthorValue(authorId);
}
export var Author;
(function (Author) {
    Author[Author["INVALID"] = 0] = "INVALID";
    Author[Author["DEVICE"] = 1] = "DEVICE";
    Author[Author["WEB"] = 2] = "WEB";
    Author[Author["USB_UTILITY"] = 3] = "USB_UTILITY";
    Author[Author["TEMPORARY"] = 4] = "TEMPORARY";
    Author[Author["PREDEFINED"] = 5] = "PREDEFINED";
})(Author || (Author = {}));
export function getAuthor(id) {
    return id >> 12;
}
